import React from 'react';
import { withTranslation } from 'react-i18next';

function NavMobileShortcut({ t, ...props }) {
  function toggleBodyClass() {
    document.body.classList.toggle('content-side-nav-open');
  }
  return (
    <a
      className="shortcut-item"
      style={{ marginLeft: 0 }}
      onClick={() => toggleBodyClass()}
    >
      <i className="md-icon">apps</i>
      <span>{t('Navigation')}</span>
    </a>
  );
}

export default withTranslation('app')(NavMobileShortcut);
